import React from 'react';
import "./index.less"

function SolutionList() {
  return (
    <div>
      {
        [1,2,3,4,5,6].map((item,index)=>{
          return (
            <a key={index} href="/detail?name=教育行业">
              <div className="solutionList">
                <div className="img-wrapper">
                  <img width="100%" src="https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/ad00f934-3c5b-4dd5-9f6d-0d7840eba7a6.png" alt="" />
                </div>
                <div className="content-wrapper">
                  <div className="title">指标预算一体化管理系统</div>
                  <div className="desc">本系统通过对预算科的指标录入管理，提供客户定制的报表生成， 且根 据不同的角色控制管理权限的分配，其权限可配置到接口， 按钮，功能 菜单等颗粒化权限，且系统大量内容用户能够自定义配置。

  报表服务与系统服务相互独立，能够支持定制化报表，并服务配备独立 的报表服务。</div>
                  <div className="footer">
                    <div className="btn">了解详情</div>
                    <div className="btn">联系我们</div>
                  </div>
                </div>
              </div>
            </a>
          )
        })
      }
     
    </div>
  );
}

export default SolutionList;
